<template>
    <div class="our-casino">
        <AllGames 
            title="WorldcupsportsCASINO" 
            :showTopBolts="false" 
            :showBottomBolts="false" 
            :showPlayButton="false"
            :showSeeAll="false"
            :filteredGameNames="['Mines', 'Crash', 'Tower', 'BlackJack']"
            :largeCards="true"
        />
    </div>
</template>

<script>
import AllGames from '@/components/AllGames';

export default {
    name: 'OurCasino',
    metaInfo: {
        title: 'Our Casino - WorldcupsportsCasino'
    },
    components: {
        AllGames
    }
}
</script>

<style scoped>
.our-casino {
    width: 100%;
    min-height: 100vh;
    padding: var(--spacing-2xl) 0;
}

@media only screen and (max-width: 1024px) {
    .our-casino {
        padding-bottom: 80px;
    }
}
</style>

